module.exports = __webpack_public_path__ + "static/media/united.9ab1f2a2.png";